import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { catchError, Observable, of, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";
import { SnackbarService } from "../../services/snackbar.service";

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private snackbarService: SnackbarService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err.status === 401) {
          let wasLoggedIn = this.authService.isLoggedIn()
          this.authService.setLogOut()
          if (wasLoggedIn) {
            this.snackbarService.error("A munkamenet lejárt. Jelentkezz be újra.")
            return of();
          }
        }
        return throwError(err);
      })
    );
  }
}
